// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3kZRx","savePackageButton":"ClientWallet_savePackageButton__21c0Z"};